module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/mandiri-logo-05e788b8dd4df64ab7c833b67336a2aa.png";